import { registerLocaleData } from "@angular/common";
import es from '@angular/common/locales/es';
import { EventEmitter, Injectable, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { GenericComponent } from "./generic-component";

declare var $: any;

@Injectable()

export class GenericModalComponent extends GenericComponent {

    @Output() closeModalEvent = new EventEmitter<null>();

    _formGroupModal: UntypedFormGroup;
    isLoadingRequest = false;
    isLoadingPage = false;
    returnModalString = undefined;
    returnModalSuccessString = undefined;

    public showPasswordConfirm = false;
    public showPassword = false;
    public status_code = 0;

    public progressFile: { percentage: number } = { percentage: 0 }
    public errorMessage: any = "";


    constructor(public modalName: string, public carouselName: string) {
        super();
        registerLocaleData(es);
        setTimeout(() => {
            this.initCarouselTransition(carouselName);
        });

    }

    initCarouselTransition(carouselName: string) {

        try {

            $('#' + carouselName).on('slide.bs.carousel', function (e) {
                $('.carousel-inner').addClass('transition-carousel-inner');
            });


            $('#' + carouselName).on('slid.bs.carousel', function () {
                $('.carousel-inner').removeClass('transition-carousel-inner');
            });

            $('#' + carouselName).carousel({
                interval: false,
                touch: false,
                keyboard: false,
                ride: false
            });
        } catch (e) {
            console.log(e);
        }
    }



    public set modalNameValue(v: string) {
        this.modalName = v;
    }



    public set carouselNameValue(v: string) {
        this.carouselName = v;
    }


    validateStepInputData() {

        this._formGroupModal.markAllAsTouched();

        if (this._formGroupModal.invalid) return;

        this.nextStepCarousel();
    }

    isValidFormGroupModal() {
        this._formGroupModal.markAllAsTouched();

        if (this._formGroupModal.invalid) return false;

        return true;
    }

    setDataError(err: any) {

        this.showStepError();

        this.errorMessage = err;
        console.log(err);

        setTimeout(() => {
            this.isLoadingRequest = false;
        }, 200);
    }

    setDataResponse() {
        this.showStepSuccess();

        setTimeout(() => {
            this.isLoadingRequest = false;
        }, 200);

    }

    nextStepCarousel() {
        $("#".concat(this.carouselName)).carousel("next");
    }

    setStepCarousel(step) {
        $("#".concat(this.carouselName)).carousel(step);
    }

    resetStepCarousel() {
        $("#".concat(this.carouselName)).carousel(0);
        $('.form-steps .step').removeClass('ok active');
        $('.form-steps .step:first').addClass('active');
        this.isLoadingRequest = false;
    }
    prevStepCarousel() {
        $("#".concat(this.carouselName)).carousel("prev");
    }

    showStepSuccess() {
        $("#".concat(this.carouselName)).carousel($("#".concat(this.carouselName, " .successSlide")).index());
        $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
        $('.form-steps .step:last-child').addClass('active').removeClass('ok');
        this.isLoadingRequest = false
    }

    showStepError() {
        $("#".concat(this.carouselName)).carousel($("#".concat(this.carouselName, " .errorSlide")).index());
        $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
        $('.form-steps .step:last-child').addClass('active').removeClass('ok');

        setTimeout(() => {
            this.isLoadingRequest = false;
        }, 200);
    }

    showStepCustom(stepName: string) {
        $("#".concat(this.carouselName)).carousel($("#".concat(this.carouselName, ` .${stepName}`)).index());
        $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
        $('.form-steps .step:last-child').addClass('active').removeClass('ok');

        setTimeout(() => {
            this.isLoadingRequest = false;
        }, 200);

    }

    passwordShowConfirm() {
        this.showPasswordConfirm = !this.showPasswordConfirm;
    }

    passwordShow() {
        this.showPassword = !this.showPassword;
    }

    closeModal() {

        if (this.returnModalString && this.returnModalString !== undefined) {

            const parent = this.modalName;
            const children = this.returnModalString;

            $(`#${parent}`).on('hidden.bs.modal', function () {
                $(`#${children}`).modal('show');
                $(`#${parent}`).off('hidden.bs.modal')
            });
        }
        $(`#${this.modalName}`).modal('hide');

        this.closeModalEvent.emit();
    }

    closeModalSuccess() {
        if (this.returnModalSuccessString && this.returnModalSuccessString !== undefined) {
            $("#" + this.returnModalSuccessString).modal('show');
        }
    }

    modalShow() {
        $("#" + this.modalName).modal('show');
    }

    modalHide() {
        $("#" + this.modalName).modal('hide');
    }

    setReturnModalString(_returnModalString: string, _returnModalSuccessString: string = undefined) {
        this.returnModalString = _returnModalString;
        this.returnModalSuccessString = _returnModalSuccessString;
    }

}
